import React, { useState } from 'react';
import './talentrequest.css';
// Import credit pack images
import threeCreditsImage from './images/3-credits.png';
import sixCreditsImage from './images/6-credits.png';
import nineCreditsImage from './images/9-credits.png';
import twelveCreditsImage from './images/12-credits.png';
import defaultTalentImage from './images/default-talent.png';
import UpdatePaymentModal from './components/UpdatePaymentModal';
import TalentRequestModal from './components/TalentRequestModal';

const TalentRequest = () => {
  // Add state for showing/hiding credit packs
  const [showCreditPacks, setShowCreditPacks] = useState(true);
  const [genderFilter, setGenderFilter] = useState('all');
  const [accentFilter, setAccentFilter] = useState('all');
  const [voiceTypeFilter, setVoiceTypeFilter] = useState('all');
  const [selectedPack, setSelectedPack] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalSelectedPack, setModalSelectedPack] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [couponCode, setCouponCode] = useState('');
  const [appliedDiscount, setAppliedDiscount] = useState(0);

  const creditPacks = [
    { credits: 3, price: 300, savings: 0, image: threeCreditsImage },
    { credits: 6, price: 570, savings: 5, image: sixCreditsImage },
    { credits: 9, price: 792, savings: 12, image: nineCreditsImage },
    { credits: 12, price: 912, savings: 24, image: twelveCreditsImage },
  ];

  const talents = [
    { id: 1, name: 'Sam Trocki', image: '/talent-images/sam-trocki.jpg', gender: 'male', accent: 'american', voiceType: 'human' },
    { id: 2, name: 'Alicia Harris', image: '/talent-images/alicia-harris.jpg', gender: 'female', accent: 'british', voiceType: 'human' },
    { id: 3, name: 'Scotty B', image: '/talent-images/scotty-b.jpg', gender: 'male', accent: 'american', voiceType: 'human' },
    { id: 4, name: 'JAIROK', image: '/talent-images/jairok.jpg', gender: 'male', accent: 'spanish', voiceType: 'ai' },
    { id: 5, name: 'Heidi West', image: '/talent-images/heidi-west.jpg', gender: 'female', accent: 'american', voiceType: 'human' },
    { id: 6, name: 'PhiLL Kross', image: '/talent-images/phill-kross.jpg', gender: 'male', accent: 'british', voiceType: 'ai' },
    { id: 7, name: 'Arianna Kross', image: '/talent-images/arianna-kross.jpg', gender: 'female', accent: 'spanish', voiceType: 'human' },
  ];

  // Filter talents based on selected filters
  const filteredTalents = talents.filter(talent => {
    if (genderFilter !== 'all' && talent.gender !== genderFilter) return false;
    if (accentFilter !== 'all' && talent.accent !== accentFilter) return false;
    if (voiceTypeFilter !== 'all' && talent.voiceType !== voiceTypeFilter) return false;
    return true;
  });

  const handleImageError = (e) => {
    e.target.src = defaultTalentImage;
  };

  // Add reset function
  const resetFilters = () => {
    setVoiceTypeFilter('all');
    setGenderFilter('all');
    setAccentFilter('all');
  };

  const handlePackSelect = (pack) => {
    setSelectedPack(pack);
    setModalSelectedPack(pack);  // Set initial modal selection
    setShowModal(true);
  };

  const handleModalPackSelect = (pack) => {
    setModalSelectedPack(pack);  // Update selected pack in modal
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedPack(null);
    setModalSelectedPack(null);
  };

  const handlePurchaseCredits = () => {
    setSelectedTalent(null);  // Close talent request modal
    setModalSelectedPack(creditPacks[0]); // Set first pack as default
    setShowModal(true);  // Open credit packs modal
  };

  const handleApplyCoupon = () => {
    if (couponCode.toLowerCase() === 'free99') {
      // Apply 100% discount
      setAppliedDiscount(modalSelectedPack ? modalSelectedPack.price : 0);
    } else {
      setAppliedDiscount(0);
    }
  };

  const getDiscountedPrice = (pack) => {
    if (couponCode.toLowerCase() === 'free99') {
      return 0;  // Free with coupon
    }
    return pack.price;
  };

  return (
    <div className="talent-request-page">
      <h1 className="talent-request-heading">Talent Request</h1>
      <div className="credit-packs-header">
        <div className="credit-info">
          <div className="total-credits">
            <span>Total Credits: 0</span>
            <button 
              className="view-credits-btn"
              onClick={() => {
                setModalSelectedPack(creditPacks[0]); // Set first pack as default
                setShowModal(true);
              }}
            >
              View Credit Packs
            </button>
          </div>
        </div>
      </div>

      {/* Purchase Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content credit-packs-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            
            <div className="modal-header">
              <div className="header-content">
                <h2>Messaging & Branding Credit Packs</h2>
                <div className="credit-conversion">1 Credit = 1 Messaging or Branding</div>
              </div>
              <div className="credit-info">
                <div className="total-credits">
                  <span>Total Credits: 0</span>
                </div>
              </div>
            </div>
            
            <div className="modal-packs">
              <div className="credit-packs-grid">
                {creditPacks.map(pack => (
                  <div 
                    className={`credit-pack ${modalSelectedPack.credits === pack.credits ? 'selected' : ''}`}
                    key={pack.credits}
                    onClick={() => handleModalPackSelect(pack)}
                  >
                    <img 
                      src={pack.image}
                      alt={`${pack.credits} Credits`}
                      className="credit-pack-image"
                    />
                    <div className="credit-amount">{pack.credits} Credits</div>
                    <div className="credit-price">${pack.price}</div>
                    <div className="credit-savings">Save {pack.savings}%</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-details">
              <div className="detail-row">
                <span>Licensed to:</span>
                <span>KrossKast</span>
              </div>
              <div className="detail-row">
                <span>Pay with:</span>
                <div className="payment-info">
                  <span>Visa 4242</span>
                  <button 
                    className="update-payment" 
                    onClick={() => setShowPaymentModal(true)}
                  >
                    Update payment
                  </button>
                </div>
              </div>
              <div className="detail-row">
                <span>Coupon Code:</span>
                <div className="coupon-input">
                  <input 
                    type="text" 
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    placeholder="Enter coupon code"
                  />
                  <button onClick={handleApplyCoupon}>Apply</button>
                </div>
              </div>
              <div className="detail-row">
                <span>Discount:</span>
                <span className="discount">${appliedDiscount.toFixed(2)}</span>
              </div>
              <div className="detail-row total">
                <span>Total:</span>
                <span>${modalSelectedPack ? getDiscountedPrice(modalSelectedPack).toFixed(2) : '0.00'}</span>
              </div>
            </div>

            <div className="modal-footer">
              <div className="terms">
                By placing your order, you agree to Krosskast's <a href="https://accounts.krosskast.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://accounts.krosskast.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms of Use</a>. 
                All messaging & branding credit packs are non-refundable and must be used within a one-year period from the date of purchase. 
                All purchased credits expire immediately if your Krosskast subscription is terminated for any reason. 
                In the event that one of our team members is unable to make this performance, we will provide you with another team member that is equally qualified.
              </div>
              <div className="footer-bottom">
                <div className="place-order-btn-container">
                  <button className="place-order-btn">PLACE YOUR ORDER</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPaymentModal && (
        <UpdatePaymentModal onClose={() => setShowPaymentModal(false)} />
      )}

      <div className="talent-section">
        <div className="talent-header">
          <div className="section-heading">Select a voice over</div>
          <div className="filter-controls">
            <select 
              value={voiceTypeFilter} 
              onChange={(e) => setVoiceTypeFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Voice Types</option>
              <option value="human">Human</option>
              <option value="ai">AI</option>
            </select>
            <select 
              value={genderFilter} 
              onChange={(e) => setGenderFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Genders</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            <select 
              value={accentFilter} 
              onChange={(e) => setAccentFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Accents</option>
              <option value="american">American</option>
              <option value="british">British</option>
              <option value="spanish">Spanish</option>
              <option value="chinese">Chinese</option>
            </select>
            <button 
              onClick={resetFilters}
              className="reset-filters-btn"
            >
              Reset
            </button>
          </div>
        </div>

        <div className="talent-grid">
          {filteredTalents.map(talent => (
            <div className="talent-card" key={talent.id}>
              <img 
                src={talent.image} 
                alt={talent.name}
                onError={handleImageError}
                loading="lazy"
              />
              <div className="hover-overlay">
                <button className="talent-action-btn play-btn">
                  {/* Remove text, icon is added via CSS */}
                </button>
                <button 
                  className="talent-action-btn request-btn"
                  onClick={() => setSelectedTalent(talent)}
                >
                  Request
                </button>
              </div>
              <div className="talent-name">{talent.name}</div>
            </div>
          ))}
        </div>
      </div>

      {selectedTalent && (
        <TalentRequestModal 
          talent={selectedTalent}
          onClose={() => setSelectedTalent(null)}
          onPurchaseCredits={handlePurchaseCredits}
        />
      )}
    </div>
  );
};

export default TalentRequest; 